import * as React from "react";
import { isModifiedClickEvent } from "@grandvisionhq/utils";
import { updateActiveVariant } from "../../../../../../context/context/actions.js";
import { getDeepestTreeLevelForSku } from "../../../utils/modules/EcommContent/context/utils/get-deepest-tree-level-for-sku.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const EcommFacetContext = React.createContext({});
const useEcommFacetContext = () => React.useContext(EcommFacetContext);
const EcommFacetProvider = ({ children }) => {
  const {
    dispatch,
    product: { variantFacetTree },
    activeVariant: { sku },
    facetConfigList
  } = useProductData();
  const handleVariantSelection = React.useCallback(
    ({ event, sku: sku2, href }) => {
      if (!event || !isModifiedClickEvent(event)) {
        event?.preventDefault();
        dispatch(updateActiveVariant({ sku: sku2 }));
        window.history.replaceState(null, "", href);
      }
    },
    [dispatch]
  );
  const [clickedFacetKeys, setClickedFacetKeys] = React.useState([]);
  const [notificationType, setNotificationType] = React.useState(
    void 0
  );
  const deepestTreeLevelForSku = getDeepestTreeLevelForSku(variantFacetTree, sku);
  const facetLevelConfig = facetConfigList?.find(
    (facet) => facet.facetKey === deepestTreeLevelForSku?.[0]?.facetKey
  );
  const isDeepestNodeRequired = !deepestTreeLevelForSku || deepestTreeLevelForSku.length <= 1 || !facetLevelConfig?.requiresUserSelection || clickedFacetKeys.includes(facetLevelConfig.facetKey);
  const value = React.useMemo(
    () => ({
      handleVariantSelection,
      isValid: isDeepestNodeRequired,
      notificationType,
      clickedFacetKeys,
      setNotificationType,
      setClickedFacetKeys
    }),
    [clickedFacetKeys, handleVariantSelection, isDeepestNodeRequired, notificationType]
  );
  return /* @__PURE__ */ React.createElement(EcommFacetContext.Provider, { value }, children);
};
export {
  EcommFacetContext,
  EcommFacetProvider,
  useEcommFacetContext
};
//# sourceMappingURL=EcommFacetContext.js.map
